'use client';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

const LAST_UPDATED = '1 June 2026';
const CONTACT_EMAIL = 'info@reprintsolution.online';

export default function AccessibilityPage() {
  return (
    <div className="min-h-screen bg-[#030812] text-white">
      <Navbar />
      <main>
        <section className="border-b border-white/10 bg-[linear-gradient(135deg,#07111f_0%,#0f1f3d_100%)] py-16">
          <div className="container mx-auto max-w-4xl px-4">
            <nav className="mb-6 flex items-center gap-2 text-sm text-slate-400">
              <Link href="/" className="hover:text-white transition">Home</Link>
              <span>/</span>
              <span className="text-white">Accessibility</span>
            </nav>
            <h1 className="text-3xl font-black text-white md:text-4xl">Accessibility Statement</h1>
            <p className="mt-3 text-slate-400 text-sm">Last updated: {LAST_UPDATED}</p>
          </div>
        </section>

        <section className="py-14">
          <div className="container mx-auto max-w-4xl px-4">
            <div className="space-y-8 text-sm leading-7 text-slate-300">

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Our Commitment</h2>
                <p className="mt-3">
                  RePrint Solution is committed to ensuring digital accessibility for people with disabilities. We continually improve the user experience for everyone and apply relevant accessibility standards.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Conformance Status</h2>
                <p className="mt-3">
                  We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. These guidelines explain how to make web content more accessible to people with disabilities.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Accessibility Features</h2>
                <ul className="mt-3 space-y-2 list-disc list-inside">
                  <li>Keyboard navigation support throughout the site</li>
                  <li>Alt text provided for all meaningful images</li>
                  <li>Sufficient colour contrast for text readability</li>
                  <li>Clear and consistent navigation structure</li>
                  <li>Descriptive link text and button labels</li>
                  <li>Responsive design for all screen sizes</li>
                </ul>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Feedback</h2>
                <p className="mt-3">
                  We welcome your feedback on the accessibility of our website. If you experience any accessibility barriers, please contact us at:{' '}
                  <a href={`mailto:${CONTACT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">{CONTACT_EMAIL}</a>
                </p>
                <p className="mt-3">We aim to respond to accessibility feedback within 5 business days.</p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
